module.exports = __webpack_public_path__ + "img/PE.7676131f.png";